import React from 'react';

import KudosBluredComponent from 'Shared/components/KudosBluredComponent/KudosBluredComponent';
import { VideoType } from 'Shared/constants/types';

import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  feedback: {
    creatorId: number;
    likeThatText?: string;
    likeThatVideo?: VideoType;
    gifUrl?: string;
  };
  creatorFirstName: string;
  onClear: Function;
};

export default function FeedbackRecognitionContent({ onClear, feedback, creatorFirstName }: Props) {
  const { likeThatText, likeThatVideo, gifUrl } = feedback;
  const { tr } = useTranslation();

  const hint = tr('perform.kudos.preview_modal.hint_gave_kudos_view_now', creatorFirstName);
  return (
    <div className="d-flex w-100 flex-column justify-content-center align-items-center cursor-pointer">
      <KudosBluredComponent
        hint={hint}
        likeThatText={likeThatText}
        likeThatVideo={likeThatVideo}
        onClear={onClear}
        gifUrl={gifUrl}
      />
    </div>
  );
}
